import * as StitchesStringify from "@stitches/stringify";
import { launcherStatesOrder } from "../../hooks/stores/launcherStatesStore";
import { convertStringFromCamelCaseToKebabCase } from "../utils/convertStringFromCamelCaseToKebabCase";

const unitlessProps: { [key: string]: 1 | undefined } = {
	animationIterationCount: 1,
	borderImageOutset: 1,
	borderImageSlice: 1,
	borderImageWidth: 1,
	boxFlex: 1,
	boxFlexGroup: 1,
	boxOrdinalGroup: 1,
	columnCount: 1,
	columns: 1,
	flex: 1,
	flexGrow: 1,
	flexPositive: 1,
	flexShrink: 1,
	flexNegative: 1,
	flexOrder: 1,
	gridRow: 1,
	gridRowEnd: 1,
	gridRowSpan: 1,
	gridRowStart: 1,
	gridColumn: 1,
	gridColumnEnd: 1,
	gridColumnSpan: 1,
	gridColumnStart: 1,
	msGridRow: 1,
	msGridRowSpan: 1,
	msGridColumn: 1,
	msGridColumnSpan: 1,
	fontWeight: 1,
	lineHeight: 1,
	opacity: 1,
	order: 1,
	orphans: 1,
	tabSize: 1,
	widows: 1,
	zIndex: 1,
	zoom: 1,
	WebkitLineClamp: 1,

	// SVG-related properties
	fillOpacity: 1,
	floodOpacity: 1,
	stopOpacity: 1,
	strokeDasharray: 1,
	strokeDashoffset: 1,
	strokeMiterlimit: 1,
	strokeOpacity: 1,
	strokeWidth: 1
}

const normalizeElementClassStyle = (elementClassStyle: any) => {
  const elementClassNormalizedStyle: { [key: string]: unknown; } = {};

  for (const [key, value] of Object.entries(elementClassStyle ?? {})) {
    if (key.startsWith(`&`)) {
      elementClassNormalizedStyle[key] = normalizeElementClassStyle(value);
    } else if (typeof value === `number` && unitlessProps[key] !== 1) {
      elementClassNormalizedStyle[key] = `${value}px`;
    } else {
      elementClassNormalizedStyle[key] = value;
    }
  }

  return elementClassNormalizedStyle;
}

export const convertElementClassToCss = (elementId: string, elementClass: any) => {
  const {
    variants: elementClassVariants,
    ...elementClassBaseStyle
  } = elementClass ?? {};

  const elementCssClassName = `launcher-element-${elementId}`;

  let elementCssValue = ``;

  // Add base styles first
  elementCssValue += StitchesStringify.stringify({
    [`.${elementCssClassName}`]: normalizeElementClassStyle(elementClassBaseStyle),
  });

  // Process variants in the order specified by launcherStatesOrder
  if (elementClassVariants) {
    for (const stateName of launcherStatesOrder) {
      const kebabStateName = convertStringFromCamelCaseToKebabCase(stateName);
      
      // Skip if this state doesn't have variants
      if (!elementClassVariants[kebabStateName]) continue;

      // Add variant styles in order
      for (const [variantOptionName, variantStyle] of Object.entries(elementClassVariants[kebabStateName] ?? {})) {
        elementCssValue += StitchesStringify.stringify({
          [`.${elementCssClassName}[${kebabStateName}="${variantOptionName}"]`]: normalizeElementClassStyle(variantStyle),
        });
      }
    }
  }

  return {
    className: elementCssClassName,
    value: elementCssValue,
  };
}